import * as v from '@badrap/valita'
import { api } from 'src/api'

const userStatusSchema = v.union(
  v.literal('CONFIRMED'),
  v.literal('FORCE_CHANGE_PASSWORD'),
)

export const listConnectUsers = (params: {
  organization: string
  username: string
}) =>
  api({
    schema: v
      .object({
        result: v.literal('OK'),
        users: v.array(
          v.object({
            // Arn: "arn:aws:connect:eu-central-1:385235822952:instance/1f48e893-a40d-4d23-9c17-387f151623dc/agent/00e9014f-be77-40e2-80c4-e9f81877e28b"
            Id: v.string(),
            // LastModifiedRegion: null
            // LastModifiedTime: null
            Username: v.string(),
          }),
        ),
      })
      .chain((data) =>
        v.ok([
          ...data.users.sort((a, b) => a.Username.localeCompare(b.Username)),
        ]),
      ),
    method: 'POST',
    url: '/listconnectusersv2',
    body: params,
    withAuth: true,
  })

export const listCognitoUsers = (params: {
  organization: string
  username: string
  organizationforlist: string
}) =>
  api({
    schema: v
      .object({
        result: v.literal('OK'),
        user: v.array(
          v.object({
            Username: v.string(),
            Attributes: v.array(
              v.object({
                Name: v.string(),
                Value: v.string(),
              }),
            ),
            UserCreateDate: v.string().chain((date) => v.ok(new Date(date))),
            UserLastModifiedDate: v
              .string()
              .chain((date) => v.ok(new Date(date))),
            Enabled: v.boolean(),
            UserStatus: userStatusSchema,
          }),
        ),
      })
      .chain((data) => v.ok(data.user)),
    method: 'POST',
    url: '/listcognitousers',
    body: params,
    withAuth: true,
  })

export const createCognitoUser = (params: {
  organization: string
  username: string
  code: string
  id: string
  email: string
  usernameforcreate: string
}) =>
  api({
    schema: v
      .object({
        result: v.literal('OK'),
        user: v.object({
          User: v.object({
            Username: v.string(),
            Attributes: v.array(
              v.object({
                Name: v.string(),
                Value: v.string(),
              }),
            ),
            UserCreateDate: v.string().chain((date) => v.ok(new Date(date))),
            UserLastModifiedDate: v
              .string()
              .chain((date) => v.ok(new Date(date))),
            Enabled: v.boolean(),
            UserStatus: userStatusSchema,
          }),
        }),
      })
      .chain((data) => v.ok(data.user)),
    method: 'POST',
    url: '/createcognitouserv2',
    body: params,
    withAuth: true,
  })

export const deleteCognitoUser = (params: {
  organization: string
  username: string
  usernamefordelete: string
}) =>
  api({
    schema: v
      .object({
        result: v.literal('OK'),
        user: v.object({}),
      })
      .chain((data) => v.ok(data.user)),
    method: 'POST',
    url: '/deletecognitouser',
    body: params,
    withAuth: true,
  })

export const getSubscriptions = (params: {
  organization: string
  username: string
}) =>
  api({
    schema: v
      .object({
        result: v.literal('OK'),
        subscribers: v.array(
          v.object({
            subscription_expired: v.boolean(),
            successfully_subscribed: v.boolean(),
            entitlement: v.string().chain((string) => {
              const result = v
                .object({
                  Entitlements: v.array(
                    v.object({
                      ProductCode: v.string(),
                      Dimension: v
                        .string()
                        .chain((string) =>
                          string.startsWith('mc_')
                            ? v.ok(Number(string.slice(3)))
                            : v.err('invalid Entitlements Dimension'),
                        ),
                      CustomerIdentifier: v.string(),
                      Value: v.object({
                        IntegerValue: v.number(),
                      }),
                      ExpirationDate: v
                        .string()
                        .chain((date) => v.ok(new Date(date))),
                    }),
                  ),
                })
                .try(JSON.parse(string))

              return result.ok ? v.ok(result.value) : v.err(result.message)
            }),
            companyName: v.string(),
            customerIdentifier: v.string(),
          }),
        ),
      })
      .chain((data) => v.ok(data.subscribers[0])),
    method: 'POST',
    url: '/getsubscriptions',
    body: params,
    withAuth: true,
  })
